import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';
import type { IntentClassification } from '@/types/floorplanClassification';

interface FloorplanRebuildSuggestionModalProps {
  open: boolean;
  classification: IntentClassification;
  currentVersion: number;
  rebuildCostCredits: number;
  rebuildReasonIntro: string;
  onCancel: () => void;
  onRebuild: () => void;
  onForceEdit: () => void;
}

export function FloorplanRebuildSuggestionModal({
  open,
  classification,
  currentVersion,
  rebuildCostCredits,
  rebuildReasonIntro,
  onCancel,
  onRebuild,
  onForceEdit,
}: FloorplanRebuildSuggestionModalProps) {
  const reason = classification.rebuild_reason?.trim() || 'Die Anfrage betrifft strukturelle Änderungen, die ein einzelner Edit nicht zuverlässig umsetzen kann.';

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-start gap-3">
            <AlertCircle className="h-6 w-6 flex-shrink-0 text-[#fe7f2e]" aria-hidden />
            <DialogTitle className="text-left">
              Diese Änderung lässt sich mit einer Bearbeitung nicht zuverlässig umsetzen
            </DialogTitle>
          </div>
        </DialogHeader>

        <div className="space-y-3 text-sm text-stone-700">
          <p>
            <span className="font-medium">{rebuildReasonIntro}</span>{reason}
          </p>
          <p>
            Empfehlung: Eine vollständige Neu-Generierung des Grundrisses. Ihre
            aktuelle Version V{currentVersion} bleibt erhalten.
          </p>
          <p className="text-stone-600">
            Kosten: {rebuildCostCredits === 0
              ? 'kostenlos — im Grundriss enthalten'
              : `${rebuildCostCredits} ${rebuildCostCredits === 1 ? 'Credit' : 'Credits'}`}
          </p>
        </div>

        <DialogFooter className="flex-col sm:flex-row sm:justify-end gap-2">
          <Button variant="outline" onClick={onCancel}>
            Abbrechen
          </Button>
          <Button
            onClick={onRebuild}
            className="bg-[#fe7f2e] hover:bg-[#e56b1f] text-white"
          >
            Jetzt neu generieren
          </Button>
        </DialogFooter>

        <div className="pt-3 border-t border-stone-200">
          <button
            type="button"
            onClick={onForceEdit}
            className="text-xs text-stone-500 hover:text-stone-700 underline"
          >
            Trotzdem als Bearbeitung versuchen →
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
